module.exports = __webpack_public_path__ + "img/service_img4.cc2cd222.png";